import React from "react";
import { Button, Card, Collapse, Input, Select } from "antd";
import {
    MessageCircle,
    Zap,
    Users,
    Clock,
    Heart,
    Mail,
    Phone,
    Send,
    Gift,
    ShieldCheck,
} from "lucide-react";
import WebsiteHeader from "../Components/WebsiteHeader";
import WebsiteFooter from "../Components/WebsiteFooter";

const { TextArea } = Input;

export default function Contact() {

     const handleRedirect = (url) => {
        // Sends the user to the specified external website URL
        window.location.href = url;
    };
    return (
        <div className="bg-[#fbfaff] min-h-screen text-slate-900">
            <WebsiteHeader />

            <main className="max-w-[1200px] mx-auto px-4 py-12">
                <section className="text-center py-10">
                    <div className="inline-flex bg-purple-100 text-purple-700 px-4 py-2 rounded-full font-bold text-sm">
                        🎧 We're Here to Help
                    </div>

                    <h1 className="text-5xl font-extrabold mt-5 mb-4">Contact Us</h1>

                    <p className="text-lg text-slate-600">
                        Have a question, feedback, or need help? <br />
                        Our team is here to support you.
                    </p>

                    <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-12">
                        <TopInfo icon={<Zap />} title="Fast Response" desc="We reply within 24 hours" />
                        <TopInfo icon={<Users />} title="Real People" desc="Talk to our support team" />
                        <TopInfo icon={<Clock />} title="Always Here" desc="Mon - Sun (9 AM - 8 PM)" />
                        <TopInfo icon={<Heart />} title="Sellers First" desc="Built for Meesho sellers" />
                    </div>
                </section>

                <section className="grid grid-cols-1 lg:grid-cols-2 gap-0 bg-white rounded-3xl shadow-sm border overflow-hidden">
                    <div className="blur-[2px] opacity-11 pointer-events-none select-none">
                        <div className="p-7 md:p-9 border-r">
                            <div className="flex items-center gap-3 mb-4">
                                <IconBox icon={<MessageCircle />} color="purple" />
                                <h2 className="text-2xl font-extrabold m-0">Send Us a Message</h2>
                            </div>

                            <p className="text-slate-500 mb-7">
                                Fill out the form below and we’ll get back to you as soon as possible.
                            </p>

                            <div className="space-y-5">
                                <Field label="Name">
                                    <Input size="large" placeholder="Enter your full name" />
                                </Field>

                                <Field label="Email">
                                    <Input size="large" placeholder="Enter your email address" />
                                </Field>

                                <Field label="Subject">
                                    <Select
                                        size="large"
                                        placeholder="Select a subject"
                                        className="w-full"
                                        options={[
                                            { value: "payment", label: "Payment / Credits Issue" },
                                            { value: "optimization", label: "Image Optimization Issue" },
                                            { value: "account", label: "Account Issue" },
                                            { value: "other", label: "Other" },
                                        ]}
                                    />
                                </Field>

                                <Field label="Message">
                                    <TextArea rows={6} placeholder="How can we help you?" />
                                </Field>

                                <Button
                                    type="primary"
                                    size="large"
                                    block
                                    className="h-14 bg-purple-600 font-bold rounded-xl"
                                >
                                    Send Message <Send size={18} />
                                </Button>

                                <p className="text-center text-slate-500 text-sm">
                                    🔒 Your information is safe with us. We never share your data.
                                </p>
                            </div>
                        </div>

                          <div className="absolute inset-0 bg-white/50 flex items-center justify-center">
                            <div className="bg-purple-600 text-white px-8 py-4 rounded-2xl font-bold text-lg shadow-lg">
                                Coming Soon
                            </div>
                        </div>
                    </div>


                    <div className="p-7 md:p-9">
                        <h2 className="text-2xl font-extrabold mb-8">
                            Other Ways to Reach Us
                        </h2>

                        {/* <ReachCard
                            color="green"
                            icon={<MessageCircle />}
                            title="Chat on WhatsApp"
                            desc="Get instant help on WhatsApp"
                            button="Chat Now"
                            url={'https://wa.me/918602490161?text=Hi Shipless Tool'}
                            
                        /> */}

                        <ReachCard
                            color="purple"
                            icon={<Mail />}
                            title="Email Support"
                            desc="support@shipless.in"
                            button="Send Email"
                            url={'mailto:support@://shipless.in'}
                        />

                        {/* <ReachCard
                            color="orange"
                            icon={<Phone />}
                            title="Call Us"
                            desc="+91 8602490161"
                            button="Call Now"
                            url={'tel:+918602490161'}
                        /> */}

                        <ReachCard
                            color="blue"
                            icon={<Clock />}
                            title="Support Hours"
                            desc="Mon - Sun: 9:00 AM - 8:00 PM"
                            sub="We’re available all 7 days"
                        />
                        <ReachCard
  color="purple"
  icon={<Mail />}
  title="Business Legal Name"
  desc="GWALAX ONLINE SERVICES"
/>
                    </div>
                </section>

                <section className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-8">
                    <Card className="rounded-2xl shadow-sm">
                        <h2 className="text-xl font-extrabold mb-5">
                            Frequently Asked Questions
                        </h2>

                        <Collapse
                            bordered={false}
                            items={[
                                {
                                    key: "1",
                                    label: "How quickly will I get a response?",
                                    children: "Usually within 24 working hours.",
                                },
                                {
                                    key: "2",
                                    label: "What are your support hours?",
                                    children: "Mon - Sun, 9:00 AM - 8:00 PM.",
                                },
                                {
                                    key: "3",
                                    label: "Can I get a refund if I’m not satisfied?",
                                    children: "Please contact support and no refund",
                                },
                                {
                                    key: "4",
                                    label: "How do credits work?",
                                    children: "1 Credit = ₹1 and one optimization costs 10 credits.",
                                },
                                {
                                    key: "5",
                                    label: "I found a bug or issue. What should I do?",
                                    children: "Send us a message with details and screenshots if possible.",
                                },
                            ]}
                        />
                    </Card>

                    <Card className="rounded-2xl shadow-sm bg-purple-50">
                        <h2 className="text-2xl font-extrabold">
                            We Love Hearing from Sellers! 💜
                        </h2>

                        <p className="text-slate-600 mt-5 leading-7">
                            Your feedback helps us improve ShipLess AI and build better tools
                            for Meesho sellers like you. Don’t hesitate to reach out!
                        </p>

                        <div className="mt-8 bg-white/70 rounded-2xl p-5 flex gap-4">
                            <IconBox icon={<ShieldCheck />} color="purple" />
                            <div>
                                <h3 className="font-bold m-0">
                                    Built by a Meesho Seller, for Meesho Sellers
                                </h3>
                                <p className="text-slate-500 m-0 mt-2">
                                    We understand your challenges and are here to help you save more
                                    on shipping and grow your business.
                                </p>
                            </div>
                        </div>
                    </Card>
                </section>

                <section className="mt-8 bg-purple-50 rounded-2xl p-7 flex flex-col md:flex-row md:items-center md:justify-between gap-5">
                    <div className="flex items-center gap-5">
                        <div className="text-6xl">🎁</div>
                        <div>
                            <h2 className="text-2xl font-extrabold m-0">
                                New Here? Get 30 Free Credits!
                            </h2>
                            <p className="text-slate-600 m-0 mt-2">
                                Join the beta and try ShipLess AI risk-free.
                            </p>
                        </div>
                    </div>

                    <Button
                    onClick={() => handleRedirect('https://dashboard.shipless.in/')}
                        type="primary"
                        size="large"
                        className="bg-purple-600 h-12 px-8 font-bold"
                    >
                        Get 30 Free Credits →
                    </Button>
                </section>
            </main>

            <WebsiteFooter />
        </div>
    );
}

function Field({ label, children }) {
    return (
        <div>
            <label className="font-bold block mb-2">{label}</label>
            {children}
        </div>
    );
}

function TopInfo({ icon, title, desc }) {
    return (
        <div className="flex items-center gap-3 text-left">
            <IconBox icon={icon} color="purple" />
            <div>
                <h3 className="font-bold m-0">{title}</h3>
                <p className="text-slate-500 m-0 text-sm">{desc}</p>
            </div>
        </div>
    );
}

function ReachCard({ color, icon, title, desc, sub, button,url }) {
    const bg = {
        green: "bg-green-50 border-green-100",
        purple: "bg-purple-50 border-purple-100",
        orange: "bg-orange-50 border-orange-100",
        blue: "bg-blue-50 border-blue-100",
    };

    const handleRedirect = (url) => {
        // Sends the user to the specified external website URL
        window.location.href = url;
    };

    return (
        <div className={`rounded-2xl border p-5 mb-5 ${bg[color]}`}>
            <div className="flex items-center justify-between gap-4">
                <div className="flex items-center gap-4">
                    <IconBox icon={icon} color={color} />
                    <div>
                        <h3 className="font-bold m-0">{title}</h3>
                        <p className="text-slate-600 m-0 mt-1">{desc}</p>
                        {sub && <p className="text-slate-500 m-0 mt-1">{sub}</p>}
                    </div>
                </div>

                {button && (
                    <Button onClick={() => handleRedirect(url)}  className="font-bold">
                        {button}
                    </Button>
                )}
            </div>
        </div>
    );
}

function IconBox({ icon, color }) {
    const map = {
        purple: "bg-purple-100 text-purple-600",
        green: "bg-green-100 text-green-600",
        orange: "bg-orange-100 text-orange-600",
        blue: "bg-blue-100 text-blue-600",
    };

    return (
        <div
            className={`w-12 h-12 rounsded-xl flex items-center justify-center shrink-0 ${map[color]}`}
        >
            {icon}
        </div>
    );
}